export default defineNuxtRouteMiddleware(async (to, from) => {
   const { getAuthed, user } = await useAuthStore();
   const { logWarn } = useDebugger();

   const noDisciplineNeeded = ["school-homepage", "login-modal", "login", "pd-course"].includes(to?.name as string);
   // console.log("Discipline Middleware - Global:", to.name, to.params, noDisciplineNeeded);
   if (noDisciplineNeeded) return;

   if (!to?.params?.discipline) {
      logWarn("DISCIPLINE MIDDLEWARE: No discipline specified");
      return;
   }

   const useHasAccess = user?.school?.disciplines.includes(
      disciplineId(to?.params?.discipline),
   );
   // logWarn("Discipline - Global:", getAuthed, useHasAccess);

   if (getAuthed && !useHasAccess) {
      // return abortNavigation("You do not have access to this discipline");
      return navigateTo("/login", {
         redirectCode: 403,
      });
   }
});
